import React, { FunctionComponent } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Section from 'components/UI/Section';
import { Box } from '@material-ui/core';
import clsx from 'clsx';
import { ColorManager } from 'components/UI/V3/ColorManager/ColorManager';
import DescriptionText from 'components/UI/V3/DescriptionText/DescriptionText';

interface CalendarCodeProps {
    staffColor: string | null;
    onChange: (staffColor: string | null) => void;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: '100%',

            [theme.breakpoints.up('md')]: {
                height: 221
            }
        },
        section: {
            height: '100%'
        },
        bodySection: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            padding: '0px 16px',

            [theme.breakpoints.up('md')]: {
                paddingLeft: '33px',
                paddingRight: '33px',
                paddingTop: '20px',
                paddingBottom: '20px'
            },
            [theme.breakpoints.up('xl')]: {
                paddingLeft: '44px',
                paddingRight: '43px',
                paddingTop: '24px',
                paddingBottom: '24px'
            }
        },
        description: {
            color: '#7A7A7A'
        }
    })
);

export const CalendarCode: FunctionComponent<CalendarCodeProps> = props => {
    const classes = useStyles();

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Section
                title="Calendar Code"
                className={classes.section}
            >
                <Box className={classes.bodySection}>
                    <DescriptionText
                        text="Select a color to identify this team member on the calendar."
                        className={classes.description}
                    />
                    <ColorManager
                        color={props.staffColor}
                        onChange={props.onChange}
                    />
                </Box>
            </Section>
        </Box>
    );
};

export default CalendarCode;
